import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { api } from "./index.api";
import { Category } from "../../types/category";
import { FilterQuery } from "../../types/query";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import toastError from "../../components/notif";

function categoriesApiErrorHandler(error: FetchBaseQueryError) {
  switch (error.status) {
    default:
      return toastError("unknown error please try again later");
  }
}

const categoriesAdapter = createEntityAdapter<Category, string>({
  selectId: (item: Category) => item._id,
});
const categoriesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCaategories: builder.query<
      EntityState<Category, string>,
      FilterQuery<Category>
    >({
      query: (input) => "categories",
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          categoriesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      transformResponse(baseQueryReturnValue, meta, arg) {
        return categoriesAdapter.addMany(
          categoriesAdapter.getInitialState(),
          baseQueryReturnValue as any
        );
      },
      providesTags: ["categories"],
    }),

    addCategory: builder.mutation<void, { title: string; desc?: string }>({
      query: (input) => ({
        url: "/categories",
        method: "POST",
        body: input,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          categoriesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags(res, err) {
        if (err) return [];
        return ["categories"];
      },
    }),
    updateCategory: builder.mutation<
      void,
      { categoryId: string; data: Partial<Category> }
    >({
      query: (input) => ({
        url: `/categories/${input.categoryId}`,
        method: "PUT",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          categoriesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags(res, err) {
        if (err) return [];
        return ["categories"];
      },
    }),

    deleteCategory: builder.mutation<void, { categoryId: string }>({
      query: (input) => ({
        url: `/categories/${input.categoryId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          categoriesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags(res, err) {
        if (err) return [];
        return ["categories"];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCaategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoriesApi;
